import { Fragment, useEffect, useState } from 'react';
import {
  Grid,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Table,
  TableHead,
} from '@mui/material';
import MuiRadioGroup from './components/MuiRadioGroup';

import { IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';
import { StyledTableCellTwo } from 'routes/Main/style';
import { Box, Stack, useTheme } from '@mui/system';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
  setSum1: (sum1: number) => void;
}

const Contents1 = (props: Props) => {
  const { disabled, getValues, setValue, setSum1 } = props;

  const [num01, setNum01] = useState(
    getValues('kdsq_c_01') ? getValues('kdsq_c_01') : 0
  );
  const [num02, setNum02] = useState(
    getValues('kdsq_c_02') ? getValues('kdsq_c_02') : 0
  );
  const [num03, setNum03] = useState(
    getValues('kdsq_c_03') ? getValues('kdsq_c_03') : 0
  );
  const [num04, setNum04] = useState(
    getValues('kdsq_c_04') ? getValues('kdsq_c_04') : 0
  );
  const [num05, setNum05] = useState(
    getValues('kdsq_c_05') ? getValues('kdsq_c_05') : 0
  );

  useEffect(() => setSum1(num01 + num02 + num03 + num04 + num05));

  return (
    <Fragment>
      <Typography
        sx={{ fontSize: '12px', fontWeight: 400, margin: '38px 0px 0px 20px' }}
      >
        본 설문은 인지기능장애평가를 위한 문진표입니다. 아래의 각 항목에 대하여,
        1년 전과 비교하여 현재 상태에 해당하는 곳에 표시해 주십시오. (동행한
        가족이 있으면 가족이 작성하시고, 없으면 본인이 작성하십시오.)
      </Typography>
      <SectionTitle title="Memory (KDSQ-M)" />

      <Grid item xs={12}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  padding: '16px',
                  whiteSpace: 'nowrap',
                  fontSize: '12px',
                }}
              ></StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  fontSize: '12px',
                  paddingLeft: '30px',
                }}
              >
                <Stack direction="row" gap={16.5}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                    아니다(0점)
                  </Typography>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                    가끔 그렇다(1점)
                  </Typography>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                    자주 그렇다(2점)
                  </Typography>
                </Stack>
              </StyledTableCellTwo>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  1. 오늘이 몇 월이고, 무슨 요일인지를 모른다.
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_01')}
                  onChange={v => {
                    setValue('kdsq_c_01', Number(v));
                    setNum01(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                  maxHeight={50}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  2. 자기가 놔둔 물건을 찾지 못 한다.
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_02')}
                  onChange={v => {
                    setValue('kdsq_c_02', Number(v));
                    setNum02(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  3. 같은 질문을 반복해서 한다.
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_03')}
                  onChange={v => {
                    setValue('kdsq_c_03', Number(v));
                    setNum03(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  4. 약속을 하고서 잊어버린다.
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_04')}
                  onChange={v => {
                    setValue('kdsq_c_04', Number(v));
                    setNum04(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  5. 물건을 가지러 갔다가 잊어버리고 그냥 온다.
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_05')}
                  onChange={v => {
                    setValue('kdsq_c_05', Number(v));
                    setNum05(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    </Fragment>
  );
};

export default Contents1;
